import { combineValidators, isRequired } from "revalidate";

export const fields = ["rentalAccommodation", "departureDate", "duration"];

export const validate = combineValidators({
	rentalAccommodation: isRequired({
		message: "TODO offer isRequired",
	}),
	duration: isRequired({
		message: "TODO duration isRequired",
	}),
	departureDate: isRequired({
		message: "TODO departureDate isRequired",
	}),
});
